import fetch from 'isomorphic-fetch';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const CREATE_COUPON_REQUEST = 'farmakom/user/CREATE_COUPON_REQUEST';
const CREATE_COUPON_SUCCESS = 'farmakom/user/CREATE_COUPON_SUCCESS';
const CREATE_COUPON_FAILURE = 'farmakom/user/CREATE_COUPON_FAILURE';

const LOAD_USER_COUPONS_REQUEST = 'farmakom/user/LOAD_USER_COUPONS_REQUEST';
const LOAD_USER_COUPONS_SUCCESS = 'farmakom/user/LOAD_USER_COUPONS_SUCCESS';
const LOAD_USER_COUPONS_FAILURE = 'farmakom/user/LOAD_USER_COUPONS_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// THUNK
export function createCoupon(coupon) {
  return function(dispatch, getState) {
    const { endpoint, method, headers, body } = api.createCoupon(coupon);
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({ type: CREATE_COUPON_REQUEST });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (!response.error && response.ok) {
          response.json().then(data => {
            dispatch({
              type: CREATE_COUPON_SUCCESS,
              payload: data,
            });
          });
        } else {
          response.json().then(data => {
            dispatch({
              type: CREATE_COUPON_FAILURE,
              error: data.message,
            });
          });
        }
      })
      .catch(error => {
        dispatch({
          type: CREATE_COUPON_FAILURE,
          error,
        });
      });
  };
}

export function loadUserCoupons() {
  return function(dispatch, getState) {
    const { endpoint, method, headers, body } = api.loadUserCoupons();
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({ type: LOAD_USER_COUPONS_REQUEST });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            dispatch({
              type: LOAD_USER_COUPONS_SUCCESS,
              payload: data,
            });
          });
        } else {
          dispatch({
            type: LOAD_USER_COUPONS_FAILURE,
            error: 'Error fetching coupons',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: LOAD_USER_COUPONS_FAILURE,
          error,
        });
      });
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  error: '',
  loading: false,
  userCoupons: [],
};

export default function couponReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        userCoupons: action.payload,
        error: '',
      };
    case CREATE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case LOAD_USER_COUPONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_USER_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        userCoupons: action.payload,
      };
    case LOAD_USER_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
